import hash from '../hash';

export function getPlacesNow(event) {
  const daysCount = event.topics.length;
  const maxPlaces = daysCount > 4 ? 5000 : daysCount * 1000;
  const spread = getSpread(event);

  const { hoursPassed, hoursBeforeToStartCount } = getHours(event);

  const total = maxPlaces + maxPlaces * spread;
  const placesPerHour = Math.round(total / hoursBeforeToStartCount);

  return placesPerHour * hoursPassed;
}

export function getPlacesTotal(placesNow) {
  return Math.floor(placesNow * 1.17);
}

function getSpread(event) {
  const daysCount = event.topics.length;
  const rawSpread = daysCount * 4;
  const slug = event.slug;
  const hashSpread = hash(slug, rawSpread + 1);
  const isMinus = hash(slug, 2);
  return (isMinus ? -hashSpread : hashSpread) / 100;
}

function getHours(event) {
  const finalStartDate = new Date(event.finalStartDateUtc);
  const currentDate = new Date();

  const hoursLeft = Math.round((finalStartDate - currentDate) / 3600000);

  const daysBeforeToStartCount = 7;
  const hoursBeforeToStartCount = daysBeforeToStartCount * 24;
  let hoursPassed = hoursBeforeToStartCount - hoursLeft;

  const minHours = 10;
  const maxHours = hoursBeforeToStartCount;

  if (hoursPassed < minHours) {
    hoursPassed = minHours;
  }

  if (hoursPassed > maxHours) {
    hoursPassed = maxHours;
  }

  return { hoursLeft, hoursPassed, hoursBeforeToStartCount };
}
